export default "__VITE_ASSET__1da6ff89__"